import { render, staticRenderFns } from "./tianmi_test.vue?vue&type=template&id=365a1e8e&scoped=true&"
import script from "./tianmi_test.vue?vue&type=script&lang=js&"
export * from "./tianmi_test.vue?vue&type=script&lang=js&"
import style0 from "./tianmi_test.vue?vue&type=style&index=0&id=365a1e8e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "365a1e8e",
  null
  
)

export default component.exports